// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"368":"Changepassword","810":"registView","939":"activateView","966":"login"}[chunkId] + "." + {"368":"f3568639","810":"82b320fb","939":"dd9da740","966":"a4a5b59a"}[chunkId] + ".css";
};